module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Archive-8b2ef0b631321c175d30a119c952c4f9.svg";